<template>
    <span>
        <button type="button" class="btn" @click="() => show_dialogs.send_cbr=true">Multi-account CBR</button>
        <multi-account-cbr-dialog :show="show_dialogs.send_cbr"
                                     :selected_employers="selected_employers"
                                     @close="show_dialogs.send_cbr = false"
        ></multi-account-cbr-dialog>
    </span>
</template>

<script>
import MultiAccountCbrDialog from "./multi-account-cbr-dialog";

export default {
    components: {MultiAccountCbrDialog},
    props: [
        'selected_employers'
    ],
    data() {
        return {
            show_dialogs: {
                send_cbr: false
            }
        };
    },
}
</script>
